import { render, staticRenderFns } from "./VideoQuiz.vue?vue&type=template&id=af3a17a4&"
import script from "./VideoQuiz.vue?vue&type=script&lang=ts&"
export * from "./VideoQuiz.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports